!(async function () {
  function e(e) {
    const t = `; ${document.cookie}`.split(`; ${e}=`);
    if (2 === t.length) return t.pop().split(";").shift();
  }
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  function t(e, ...t) {
    let o = e.raw,
      a = "";
    return (
      t.forEach((e, t) => {
        let n = o[t];
        Array.isArray(e) && (e = e.join("")),
          n.endsWith("$") && ((e = htmlEscape(e)), (n = n.slice(0, -1))),
          (a += n),
          (a += e);
      }),
      (a += o[o.length - 1])
    );
  }
  const o = {
      mens: "sneakers/mens",
      womens: "sneakers/womens",
      "#Upcoming": "upcoming-launches",
      "#Trending": "trending-sneakers",
      "#Sportstyle": "sportstyle-sneakers",
      "#NFT": "nft-sneakers",
      "#Conscious": "vegan-sustainable-sneakers",
      "#Vegan": "vegan-sustainable-sneakers",
      "#Classic": "classic-sneakers",
      "#Luxury": "luxury-sneakers",
      "#Limited": "limited-release-sneakers",
      "#Collaboration": "sneaker-collaborations",
      "#Exclusive": "exclusive-sneakers",
      "#Streetwear": "streetwear-sneaker-brands",
      "#New Designer": "new-designer",
      "#Sport": "sports-running-shoes",
      "Slip On Sneakers": "slip-on-sneakers",
      "Low Top Sneakers": "low-top-sneakers",
      "High Top Sneakers": "high-top-sneakers",
      "Running Shoes": "running-shoes",
    },
    a = (e) => t`
    <figure
      id="product-images-product-quickview-template"
      class="product-images owl-carousel owl-loading"
    >
      ${e.map((e, i) => {
        function imgURL(src, size) {
          // remove any current image size then add the new image size
          return src
            .replace(
              /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,
              "."
            )
            .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
              return "_" + size + match;
            });
        }
        const lowQualitySrc = imgURL(e.src, "small");
        return t`
          <div class="product-gallery__image">
            <img
              src="${lowQualitySrc}"
              class="attachment-shop_single size-shop_single"
              data-src="${e.src}"
              alt="${e.alt}"
              onload="this.onload=null; this.src=this.getAttribute('data-src'); this.style='width: 100% !important';"
              sizes="(max-width: 1200px) 100vw, 1200px"
              style="filter: blur(5px); width: 100% !important; ${
                i == 0 ? "" : "display: none !important;"
              }"
            />
          </div>
        `;
      })}
    </figure>
  `,
    n = (f) => t`
       	 ${f
           .split(",")
           .sort((a, b) => {
             if (a.includes("men")) {
               if (a.includes("women") && b.includes("men")) {
                 return 1;
               }
               return -1;
             }
             return;
           })
           .map((e, i) => {
             const arr = f.split(", ");
             const hasBoth = arr.includes("mens") && arr.includes("womens");
             if (hasBoth && i == 0) {
               return t`
              <a href="/collections/sneakers" class="product-tags highlight">Unisex</a>
            `;
             } else if (
               (e.includes("men") || e.includes("women")) &&
               !hasBoth
             ) {
               return t`
          <a href="/collections/${
            o[e.trim()]
          }" class="product-tags highlight">${e}</a>
        `;
             }
             if (hasBoth) {
               if (e.includes("men") || e.includes("women")) return;
             }
             return t`
          <a href="/collections/${o[e.trim()]}" class="product-tags">${e}</a>
        `;
           })}
	
  `,
    s = (e) => {
      let hasAmerica = false;
      let hasUK = false;
      let hasEU = false;
      let isUK = window.Shopify.country == "GB";
      let isAmerica = window.Shopify.country == "US";
      let isEU =
      window.Shopify.country == "AT" ||
        window.Shopify.country == "BE" ||
        window.Shopify.country == "CY" ||
        window.Shopify.country == "EE" ||
        window.Shopify.country == "FI" ||
        window.Shopify.country == "FR" ||
        window.Shopify.country == "DE" ||
        window.Shopify.country == "GR" ||
        window.Shopify.country == "IE" ||
        window.Shopify.country == "IT" ||
        window.Shopify.country == "LV" ||
        window.Shopify.country == "LT" ||
        window.Shopify.country == "LU" ||
        window.Shopify.country == "MT" ||
        window.Shopify.country == "NL" ||
        window.Shopify.country == "PT" ||
        window.Shopify.country == "SK" ||
        window.Shopify.country == "SI" ||
        window.Shopify.country == "ES";
       
        let isInt = !isUK && !isEU && !isAmerica;
        
      //       UK shows - INT, UK - Fallback - INT, US, EU
      // EU Shows - INT, EU - Fallback, INT, US, UK
      // US Shows - INT, US - Fallback INT, UK, EU (edited)

      let filteredOptions = [];
      console.log(e);
      e.forEach((option) => {
        if (option.title.includes("/ INT")) {
          filteredOptions.push(option);
        }
        else if (isEU && option.title.includes("/ EU")) {
          filteredOptions.push(option);
          hasEU = true;
        }

        else if ((isAmerica || isInt) && option.title.includes("/ US")) {
          hasAmerica = true;
          filteredOptions.push(option);
        }

        else if ((isUK && option.title.includes("/ UK"))) {
          filteredOptions.push(option);
          hasUK = true;
        }
      });
      if(e.length === 1) {
        filteredOptions = e;
      }


      function includeOptionTypes(e, types){
        let returnVal = [];
        e.forEach((option) => {
          // check if option.title includes one of the types
          types.forEach((type) => {
            if (option.title.includes(type)) {
              returnVal.push(option);
            }
          })
        });
        return returnVal;
      };

      function getCurrencyFromProductName(productName, activeCurrency){
      if(productName.includes("INT")){
        return activeCurrency;
      } else if (productName.includes("US")) {
        return "$";
      } else if (productName.includes("UK")) {
        return "£";
      } else if (productName.includes("EU") || productName.includes("INT")) {
        return "€";
      } else if (productName.includes("JP")) {
        return "¥";
      }
      }

      function getCurrencyNameFromProductName(productName, activeCurrency) {
        if (productName.includes("INT")) {
          return 'X1';
        } else if (productName.includes("US")) {
          return "USD";
        } else if (productName.includes("UK")) {
          return "GBP";
        } else if (productName.includes("EU")) {
          return "EUR";
        } else if (productName.includes("JP")) {
          return "JPY";
        }
      }
      

      if(!filteredOptions.length && isEU) {
        filteredOptions = includeOptionTypes(e, ['US', 'EU']);
      }

      if(!filteredOptions.length && isAmerica) {
        filteredOptions = includeOptionTypes(e, ['UK', 'EU']);
      }

      if(!filteredOptions.length && isUK) {
        filteredOptions = includeOptionTypes(e, ['US', 'EU']);
      }

      var showCurrency =
        (isUK && !hasUK) || (isAmerica && !hasAmerica) || (isEU && !hasEU);

        // showCurrency = showCurrency && !e.title.includes('INT');
        // ${e.option2.split("-").length > 1 ? e.option2.split("-")[0] : e.option2} (product name splitter)
      return t` <div class="store-select-width modal-width">
      ${filteredOptions.map(
        (e, o) => {
          var product_name_sanitized = e.option2?.split(" -").length > 1 ? e.option2.split(" -").slice(0, -1).join("-") : e.option2;
          var product_name_sanitized_dash = product_name_sanitized.replace(/ /g, "-");
          var container_id = `${product_name_sanitized}-${e.option3}-logo`;
          return t`
          <div class="swatch clearfix" data-option-index=${o + 1}>
           <div data-value="${
             e.option2
           }" class="swatch-node available" style="${
          o == 0 ? "background: transparent;" : ""
        }">
              <input
                id="swatch-${o}-${ e.option2}-${ e.option3}"
                type="radio"
                name="option-1"
                value="${e.option2}-${e.option3}"
              />
  
  <label for="swatch-${o}-${ e.option2}-${ e.option3}">
  <div id="${container_id}" class="variant-logo" data-value="${product_name_sanitized_dash}">${e.option2[0]}</div>
  ${product_name_sanitized}
  ${
    e.option2.includes("StockX") ||
    e.option2.includes("Goat") ||
    e.option2.includes("Klelt")
      ? `<div class="tag-variant-store-modal">Marketplace</div>`
      : ""
  }
    ${
      showCurrency && !e.title.includes("INT")
        ? `<div class="tag-variant-currency">${getCurrencyNameFromProductName(
            e.title,
            i[window.Shopify.currency.active]
          )}</div>`
        : ""
    }
  <a target="_blank" href=${
    e.sku
  } class="buy-now-btn"> ${getCurrencyFromProductName(
          e.title,
          i[window.Shopify.currency.active]
        )} ${e?.price?.split(".")[0]}
  </a> </label>
            </div>
          </div>
        `;
        }
      )}
    </div>`;
    },
    i = { USD: "$", GBP: "£", CAD: "$", EUR: "€", JPY: "¥", CNY: "¥" };
  var l,
    r,
    c,
    d = function (l) {
      const r = document.querySelector("#email-notify-form");
      r &&
        (console.log(r),
        r.addEventListener("submit", function (e) {
          e.preventDefault();
          const t = r.elements.email.value;
          console.log(t);
          const o =
            ((a = window.SIP_GLOBAL_SKU.product),
            (n = { name: "guest", email: t }),
            console.log(a),
            {
              product_id: a.id,
              variant_title: a.title,
              vendor: a.vendor,
              sku: a.variants[0].sku,
              language: "en",
              handle: a.handle,
              quantity: 1,
              shop: "sneakinpeace.myshopify.com",
              message: null,
              name: n.name,
              email: n.email,
              send_type: "email",
              variant_id: a.variants[0].id,
              product_title: a.variants[0].title,
              variant_image: a.image.src,
              product_handle: a.handle,
              variant_price: a.variants[0].price,
            });
          var a, n;
          l.post("", o, function (e) {
            l("#email-notify-form").hide(), l(".email-success").show();
          });
        })),
        l(document).on("click", ".blog-tab", function () {
          l(".blog-tab").removeClass("selected"),
            l(this).addClass("selected"),
            l(".blog-content").removeClass("active"),
            l(l(this).attr("data-id")).addClass("active");
        });

  l(document).on("click", ".mobile-sku-btn", function (e) {


    const my_element = document.getElementById("store-select-section");

    my_element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
    });


        if (l(this).attr("href") !== "#") {
          window.open(l(this).attr("href"), "_blank").focus();
        }
      });
      let c,
        d,
        u = {};

      l(document).on("click", ".search-button", function (e) {
        const activeTag = document.querySelector(".active-tag");
        window.scrollTo({ top: 0 });
        l(".search-icon").is(":visible")
          ? (l(".search-icon").hide(),
            l(".search-close-icon").show(),
            l(".search-collection-contain").css("display", "flex"),
            l(".gf-controls-search-input").focus(),
            clearAllFilter(),
            activeTag && activeTag.classList.remove("active-tag"))
          : (l(".search-icon").show(),
            l(".search-close-icon").hide(),
            l(".search-collection-contain").css("display", "none"),
            clearSearchProducts(),
            activeTag && activeTag.classList.remove("active-tag"));
      }),
        l(document).on("keypress", ".search", function (e) {
          if (13 == e.which) return !1;
        }),
        l
          .ajax({ url: window.location.href + ".json", dataType: "json" })
          .done(function (t) {
            (window.SIP_GLOBAL_SKU = t),
              (u = {
                product_id: t.product?.variants[0].product_id,
                variant_id: t.product?.variants[0].id,
              });
            const o = i[e("cart_currency")];
            l("input[name='option-1']").attr("disabled", !1),
              (c = t.product?.variants),
              l(".desktop-sku-btn").attr("href", c && c[0].sku),
              l(".price-new > .money").html(o + Math.round(c && c[0].price));
          }),
        l(document).on("click", ".product-images-wrapper", function () {
          if (window.innerWidth >= 1180) {
            l(".button-bottom").fadeToggle(),
            l("#close-overlay").fadeToggle(),
            l(".product-images-wrapper").toggleClass("expand");
          }

        }),
        (window.onpopstate = function (e) {
          // determine if going back or forwards
          e.preventDefault();
          e.stopPropagation();
          var modalContent = document.querySelector('.modal-content');
          if (modalContent) {
            l("body").removeClass("modal-open"),
            l(".product-details").hide(),
            l(".product-images-wrapper").removeClass("expand"),
            l(".sidebar-box").removeClass("show-all"),
            l(".read-more-btn").text("Read More"),
            l(".sip-modal").removeClass("sip-modal-open"),
            l("#modal-overlay").css({
              display: "none",
              opacity: "0",
              transition: "opacity 400ms ease 0s",
            }),
            l(".product-information-inner").removeClass("show-info"),
            l("#close-overlay").hide();
          }
          else {
            // reaload
            window.location.reload();
          }
        }),
      l(document).on(
          "change",
          "input[name='option-1']",
          async function (curRadio) {
            let t = d || c;
            if (!t) {
              t = await l.ajax({
                url: window.location.href + ".json",
                dataType: "json",
              });
              t = t.variants;
            }
            let o = t.find((e) => `${e.option2}-${e.option3}` === l(this).val());
            const a = i[e("cart_currency")];

            // var radios = document.querySelectorAll(
            //   '.store-select-width input[type="radio"]'
            // );
            // radios.forEach(function (innerRadio) {
            //   innerRadio.closest(".swatch-node").style.backgroundColor = "";
            // });
            // curRadio.target.closest(".swatch-node").style.backgroundColor =
            //   "white";

            let productName = o.option2.slice(0, o.option2.lastIndexOf(' - '));
            productName = o.option2.includes('-') ? productName : o.option2;
  
            l(".variant-sku").attr("href", linkMapper.convertToAffiliateLink(o.sku,window.location.href)),
               l(".variant-sku").text(`Shop from ${productName}`),
              l(".price-new > .money").html(a + Math.round(o.price));
          }
        );

      if (l(".desktop-sku-btn").is(":visible")) {
        l("input[name='option-1']")?.first().attr("checked", true);
        setTimeout(function () {
          l("input[name='option-1']")?.first().attr("checked", false);
          l("input[name='option-1']").first().click();
        }, 1000);
      }

      // open modal
      let p = document.location.pathname;
      l(document).on("click", ".open-quick-view", function (r) {
        
        r.preventDefault();
       
        let modal = document.querySelector("#quick-view-modal");
        modal.scroll(0, 0);
        l("body").addClass("modal-open"),
          l(".sip-modal").addClass("sip-modal-open"),
          l("#modal-block").addClass("modal-block-open"),
          l("#modal-info").addClass("modal-info-open"),
          l("#modal-title").addClass("modal-title-open"),
          l("#gallery").addClass("gallery-open"),
          l("#mobile-button-buy").addClass("buy-open"),
          l(".product-gallery").hide(),
          l("#modal-overlay").css({
            display: "block",
            opacity: "1",
            transition: "opacity 400ms ease 0s",
          }),
          l("#close-overlay").fadeIn();
        const c = l(this).attr("data-product"),
          p = l(this).attr("data-product-id");
        l.ajax({ url: c + ".json", dataType: "json" }).done(function (r) {
          
           // set restock rocket config (notify button)
        window._RestockRocketConfig = {
          ...window._RestockRocketConfig,
          product: r.product,
          rendered: true,
        };


          let isUK = window.Shopify.country == "GB";

          const {
            body_html: m,
            vendor: h,
            title: f,
            images: v,
            variants: y,
            tags: g,
            product_type: b,
          } = r.product;

          const restockProd = window._RestockRocketConfig?.products && window._RestockRocketConfig.products[r.product.handle]?.product;
          // Check if all variants are in stock
          let allVariantsInStock = true;
          if(restockProd) {
            for (let variant of restockProd?.variants) {
              if (!variant.available) {
                allVariantsInStock = false;
                break;
              }
            }
          }

          // Update restock button visibility based on stock status
          if (allVariantsInStock) {
            document.querySelector('.restock-rocket-button-container').style.display = 'none';
          } else {
            document.querySelector('.restock-rocket-button-container').style.display = 'flex';
          }


          window.metaProduct = r.product;
          window.metaProductVariant = y[0];
        // _360x @NEW
        let formattedPrice = (parseFloat(y[0].price.replace(/[\.,]/g, '')) / 100.0).toFixed(1);
        const wishlist = `<div id="ZlistWishlist" data-product-id="${r.product.id}"
        data-handle="${r.product.handle}" data-image="${r.product.image.src.replace('.jpg', '_360x360.jpg')}"
        data-variantname="${y[0].title}" data-title="${r.product.title}"
        data-variant="${y[0].id}"
        data-price="${formattedPrice}"></div>`
          let title = isUK ? f.replace('Sneakers', 'Sneakers') : f;
          (window.SIP_GLOBAL_SKU = r),
            (d = y),
            (u = { product_id: y[0].product_id, variant_id: y[0].id });
          // l.ajax({
          //   dataType: "json",
          // }).done(function ({ isAvailable: e }) {
          //   !1 === e &&
          //     (l(".swatch").css("opacity", "0.4"),
          //     l(".variant-sku").attr("href", "#"));

          //   if (l(".desktop-sku-btn").is(":visible")) {
          //     l("input[name='option-1']")?.first().attr("checked", true);
          //     setTimeout(function () {
          //       l("input[name='option-1']")?.first().attr("checked", false);
          //       l("input[name='option-1']").first().click();
          //     }, 1000);
          //   }
          // });
          setTimeout(function () {
            if (l(".desktop-sku-btn").is(":visible")) {
                l("input[name='option-1']")?.first().attr("checked", true);
                  l("input[name='option-1']")?.first().attr("checked", false);
                  l("input[name='option-1']").first().click();
              }
          }, 100);

          var wishlistElement = document.getElementById('ZlistWishlist');
          if (wishlistElement) {
            wishlistElement.remove(); //remove to re-add
          }

          history.pushState({ page: 3 }, "title 3", c),
            gtag("send", "pageview", location.pathname),
            l(".sidebar-box").html(m),
            l(".product-single__vendor").html(
              `<a href="/collections/${h.split(" ").join("-")}">${h}</a>`
            ),
            l(".product-page-read-more").removeClass("hide"),
            l(".product-page-description").addClass("minimized"),
            l(".product_title").text(title),
            l("#wishlist-btn").prepend(wishlist), //wishlist
            l(".product-gallery").html(a(v)),
            l(".store-selection").html(s(y)),
            l(".product-tags-placement").html(n(g)),
            l(".product-tags-placement").append(
              `<a href="/collections/${
                o[b.trim()]
              }" class="product-tags">${b}</a>`
            );
            // generate wishlist 
            window.wishlistReqJqueryList();

            // listen for click event
            var wishListEventListener = window.debounceFunc(function() {
              window.toggleWishlist();
            }, 100)
            // re-add wishlist element
            wishlistElement = document.getElementById('ZlistWishlist');
            if (wishlistElement) {
              wishlistElement.removeEventListener("click", wishListEventListener, false);
              wishlistElement.addEventListener('click', wishListEventListener, false);
            }




          
            // generate logos
            const variantLogos = document.querySelectorAll('.variant-logo');
            window.results = {}; // Object to store the results of image loading
            
            variantLogos.forEach(variantLogo => {
              const containerID = variantLogo.id;
              const imageUrl = `${window.location.origin}/cdn/shop/files/logo-${variantLogo.dataset.value}.png`;
    
              loadLogoImage(containerID, imageUrl);
            });
    
            function loadLogoImage(containerID, imageUrl) {
              var img = new Image();
              img.src = imageUrl;
              window.results[containerID] = imageUrl;
    
              img.onload = function() {
                // Image loaded successfully, display the image
                var container = document.getElementById(containerID);
                container.innerHTML = `<img src="${img.src}" alt="Vendor Logo">`;
              };
    
              img.onerror = function() {
                // Image failed to load, display the fallback text
                var container = document.getElementById(containerID);
                const fallbackText = container.textContent.trim().charAt(0); // Assuming the fallback text is the first character of the vendor name
                container.textContent = fallbackText;
              };
                                  
              // Return the img object (for reference or further manipulation if needed)
              return img;
            }
          let productName = y[0]?.option2.slice(0, y[0].option2.lastIndexOf(' - '));

          productName = y[0]?.option2.includes('-') ? productName : y[0]?.option2;

          const w = i[e("cart_currency")];
          l(".price-new > .money").text(`${w}${Math.round(y[0].price)}`),
            l(".desktop-sku-btn").attr("href", y[0].sku),
             l(".desktop-sku-btn").text(`Shop from ${productName}`),
            l(".product-details").show(),
            l(".product-gallery").fadeIn(),
            l(".button-bottom").show();
        });
      }),
        l(document).on("click", "#close-overlay", function (e) {
          window._RestockRocketConfig = {
            ...window._RestockRocketConfig,
            product: undefined,
          };
          window.zooomyColl(window.$);
          e.preventDefault(),
            l(".store-select-subtitle").text("Select Store"),
            l("body").removeClass("modal-open"),
            history.replaceState({ page: 3 }, "title 3", p),
            l(".product-details").hide(),
            l(".product-images-wrapper").removeClass("expand"),
            l("#modal-block").removeClass("modal-block-open"),
            l("#modal-info").removeClass("modal-info-open"),
            l("#modal-title").removeClass("modal-title-open"),
            l("#gallery").removeClass("gallery-open"),
            l("#mobile-button-buy").removeClass("buy-open"),
            l(".sidebar-box").removeClass("show-all"),
            l(".sip-modal").removeClass("sip-modal-open"),
            l(".product-gallery")?.removeClass("full-size"),
            l(".product-information-inner")?.removeClass("show-info"),
            l("#modal-overlay").css({
              display: "none",
              opacity: "0",
              transition: "opacity 400ms ease 0s",
            }),
            l(".button-bottom").hide(),
            l("#close-overlay").hide();
        }),
        l(document).on("click", "#modal-overlay", function () {
          window.zooomyColl(window.$);
          l(".store-select-subtitle").text("Select Store"),
            history.replaceState({ page: 3 }, "title 3", p),
            l(".product-details").hide(),
            l(".product-images-wrapper").removeClass("expand"),
            l("#modal-block").removeClass("modal-block-open"),
            l(".product-gallery")?.removeClass("full-size"),
            l("#modal-info").removeClass("modal-info-open"),
            l("#modal-title").removeClass("modal-title-open"),
            l("#gallery").removeClass("gallery-open"),
            l("#mobile-button-buy").removeClass("buy-open"),
            l(".sidebar-box").removeClass("show-all"),
            l("body").removeClass("modal-open"),
            l(".sip-modal").removeClass("sip-modal-open"),
            l(this).css({
              display: "none",
              opacity: "0",
              transition: "opacity 400ms ease 0s",
            }),
            l(".button-bottom").hide(),
            l("#close-overlay").hide(),
            l(".modal-back-in-stock").hide(),
            l(".variant-sku").text("Select store");
        });

      l(document).on("click", ".gfqv-close-modal-desktop", function () {
        const e = l("#product-overlay");
        history.pushState({ page: 3 }, "title 3", h),
          (p = h),
          l("body").removeClass("modal-open"),
          e.addClass("product-modal-close"),
          l("#product-modal-overlay").css({
            display: "none",
            opacity: "0",
            transition: "opacity 400ms ease 0s",
          });
      }),
        l(document).on("click", "#product-modal-overlay", function () {
          const e = l("#product-overlay");
          history.pushState({ page: 3 }, "title 3", h),
            (p = h),
            l("body").removeClass("modal-open"),
            e.addClass("product-modal-close"),
            l(this).css({
              display: "none",
              opacity: "0",
              transition: "opacity 400ms ease 0s",
            });
        });
    },
    u = function (e) {
      e(document).on("click", ".read-more-btn", function (t) {
        t.preventDefault();
        const o = "Read Less" === e(this).text() ? "Read More" : "Read Less";
        e(this).text(o), e(".sidebar-box").toggleClass("show-all");
      });
    },
    p = window.pageYOffset;
  window.onscroll = function () {
    var e = window.pageYOffset;
    if (p > e)
      document.getElementById("gf-tree") &&
        (document.getElementById("gf-tree").style.bottom = "0");
    else {
      document.getElementById("gf-tree") &&
        (document.getElementById("gf-tree").style.bottom = "0px");
      window.matchMedia("only screen and (max-width: 760px)").matches;
    }
    p = e;
  };

  var waitForJQuery = setInterval(function () {
    if (typeof $ != "undefined") {
      d(jQuery);
      u(jQuery);
      haveJQuery = true;
      clearInterval(waitForJQuery);
    }
  }, 10);

  var hasShown = false;

  var hasShownLogin = false;

  // overlay issue code
  const clickDivAdd = document.getElementById("blur");

  const targetDiv = document.getElementById("gf-grid");

  if (clickDivAdd) {
    clickDivAdd.addEventListener("click", function () {
      targetDiv.classList.add("bg-blur");
    });
  }

})();
